module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "gl-step-bar gl-breadcrumb breadcrumb has-arrow-separator is-medium"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/shop/cart"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('icon', {
    staticClass: "el-icon-fa",
    attrs: {
      "name": "shopping-cart",
      "scale": "1"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("Корзина")])])]), _vm._v(" "), _vm._l((_vm.steps), function(step, index) {
    return [_c('li', {
      class: [{
        'is-active': _vm.currStepIndex === index
      }]
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.moveToStep(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('icon', {
      staticClass: "el-icon-fa",
      attrs: {
        "name": step.icon,
        "scale": "1"
      }
    })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(step.label))])])])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50f62298"}!./~/vue-loader/lib/selector.js?type=template&index=0!./dev-packages/Shop/assets/site/widgets/order/StepsBar.vue
// module id = 626
// module chunks = 2